<div [class._floating-ai]="!isQuillEditor" class="w-100">
  <div *ngIf="showPreview && !isWritingAI" class="ai-preview">
    <div class="py-2 ai-title">
      {{ 'one_ai.preview' | transloco }}
    </div>
    <ng-container *ngIf="isQuillEditor; else textPreview">
      <div [innerHTML]="previewHTML"></div>
    </ng-container>
    <ng-template #textPreview>
      {{ previewText }}
    </ng-template>
  </div>
  <div class="ai-dropdown" #aiDropdown>
      <div class="ai-close" *ngIf="!isWritingAI" (click)="closeAI()">
        <one-icon name="close" class="mr-1"></one-icon>
        <span>{{ 'one_ai.close' | transloco }}</span>
      </div>
      <ng-container *ngIf="isUndo">
        <div class="py-2 d-flex align-items-center justify-content-between">
          <div class="ai-title">
            {{ transloco.translate('one_ai.action_with_choice', { choice: transloco.translate(displayPreviewChoiceKey) }) }}
          </div>
        </div>
        <ul>
          <li>
            <div class="d-flex align-items-center" (click)="setUndoAction(displayPreviewChoiceKey)">
              <img width="14" height="14" src="/app_assets/ai/undo.svg" class="mr-2" alt="">
              <span>{{ 'one_ai.undo' | transloco }}</span>
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="isWritingAI">
        <div class="ai-writing">
          <img width="14" height="14" src="/app_assets/ai/ai.svg" class="mr-2" alt="">
          <span class="ai-loading">{{ 'one_ai.ai_writing' | transloco }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="previewText && !isWritingAI && !isUndo">
        <div class="py-2 ai-title">
          {{ 'one_ai.action' | transloco }}
        </div>
        <ul>
          <li>
            <div class="d-flex align-items-center" (click)="setAction(aiAction.replace)">
              <img width="14" height="14" src="/app_assets/ai/replace.svg" class="mr-2" alt="">
              <span>{{ 'one_ai.preview_actions.replace' | transloco }}</span>
            </div>
          </li>
          <li>
            <div class="d-flex align-items-center" (click)="setAction(aiAction.insertBelow)">
              <img width="14" height="14" src="/app_assets/ai/insert-below.svg" class="mr-2" alt="">
              <span>{{ 'one_ai.preview_actions.insert_below' | transloco }}</span>
            </div>
          </li>
          <li>
            <div class="d-flex align-items-center" (click)="setAction(aiAction.discard)">
              <img width="14" height="14" src="/app_assets/ai/discard.svg" class="mr-2" alt="">
              <span>{{ 'one_ai.preview_actions.discard' | transloco }}</span>
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="!isWritingAI && !expanded && !isUndo">
        <div class="py-2 d-flex align-items-center justify-content-between">
          <div *ngIf="!showPreview" class="ai-title">{{ 'one_ai.title' | transloco }}</div>
          <div *ngIf="showPreview" class="ai-title">{{ 'one_ai.try_again' | transloco }}</div>
        </div>
        <ul>
          <li class="ai-options" *ngFor="let option of options">
              <ng-container *ngIf="!option.expandable">
                  <div class="d-flex align-items-center" (click)="onSelect(option)">
                    <img *ngIf="option.svg" width="14" height="14" [src]="option.svg" class="mr-2" alt="">
                    <span>{{ option.labelKey | transloco }}</span>
                  </div>
              </ng-container>
              <ng-container *ngIf="option.expandable">
                  <div class="d-flex align-items-center justify-content-between" (click)="toggleExpandOption(option.value, true)">
                      <div class="d-flex align-items-center">
                        <img *ngIf="option.svg" width="14" height="14" [src]="option.svg" class="mr-2" alt="">
                        <span>{{ option.labelKey | transloco }}</span>
                      </div>
                      <one-icon name="chevron-forward-outline"></one-icon>
                  </div>
              </ng-container>
          </li>
        </ul>
      </ng-container>
      <ng-container
        *ngIf="!isWritingAI && optionExpanded[expandableOptions.changeTone] && !isUndo"
        [ngTemplateOutlet]="expandedOptionTemplate"
        [ngTemplateOutletContext]="{
         titleKey: 'one_ai.submenus.change_tone',
         options: toneOptions,
         expandableOption: expandableOptions.changeTone
        }"
      >
      </ng-container>
      <ng-container
        *ngIf="!isWritingAI && optionExpanded[expandableOptions.translate] && !isUndo"
        [ngTemplateOutlet]="expandedOptionTemplate"
        [ngTemplateOutletContext]="{
         titleKey: 'one_ai.submenus.translate',
         options: languageOptions,
         expandableOption: expandableOptions.translate
        }"
      >
      </ng-container>
  </div>
</div>
<ng-template #expandedOptionTemplate let-titleKey="titleKey" let-options="options" let-expandableOption="expandableOption">
  <div class="py-2 d-flex align-items-start justify-content-between">
    <div class="ai-title">{{ titleKey | transloco }}</div>
    <div
      class="d-flex align-items-center cursor-pointer"
      (click)="toggleExpandOption(expandableOption, false)">
      <div class="ai-back">
        <one-icon name="arrow-back-outline" class="mr-1"></one-icon>
        <span>{{ 'one_ai.submenus.back' | transloco }}</span>
      </div>
    </div>
  </div>
  <ul>
    <li
      *ngFor="let option of options; let isFirst = first"
      [class._priority-language]="expandableOption === expandableOptions.translate && isFirst && showPriorityLanguage"
      (click)="onSelect(option)">
      <ng-container *ngIf="option.labelKey; else langLabel">
        {{ option.labelKey | transloco }}
      </ng-container>
      <ng-template #langLabel>{{ option.label }}</ng-template>
    </li>
  </ul>
</ng-template>
